import { connect } from 'react-redux'
import { compose, mapProps, withProps } from 'recompose'
import { getCurrentStorePhoneNumber } from 'selectors/getCurrentStore'
import { formatPhoneNumber } from 'helpers/phone-number'
import QuantityPriceView from './QuantityPrice'
import { convertNumbersToOptions } from 'helpers/options'
import range from 'lodash/range'

const withQuantityViewModel = mapProps(({ ...props }) => ({
  ...props,
  model: {
    quantity: {
      options: convertNumbersToOptions(range(1, 9))
    }
  }
}))

const withPriceInformation = withProps(({
  myStore,
  priceOld,
  priceSale,
  zeroPriceItemMessage,
  seePriceIncartMessage,
  hasMapPrice
}) => ({
  isShowSelectStore: !myStore,
  isShowPrice: myStore && (priceOld || priceSale) === 0 && !zeroPriceItemMessage,
  isShowCallStoreForPrice: Boolean(myStore && zeroPriceItemMessage),
  mapShowPhoneNumber: Boolean(myStore && hasMapPrice && seePriceIncartMessage.match(/call/i))
}))

const mapStateToProps = state => ({
  storePhoneNumber: getCurrentStorePhoneNumber(state),
  formattedStorePhoneNumber: formatPhoneNumber(getCurrentStorePhoneNumber(state))
})

const QuantityPrice = compose(
  connect(mapStateToProps),
  withQuantityViewModel,
  withPriceInformation
)(QuantityPriceView)

export default QuantityPrice
